import AWS from 'aws-sdk'
import {getOAuth2Token, refreshOAuth2Token, getUserInfo, getAwsCredentials} from '../services/cognito.js'
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'

export default {
  state: {
    accessKeyId: null,
    secretAccessKey: null,
    sessionToken: null,
    sessionExpires: null,
    userInfo: null,
    jwtToken: null,
    jwtPayload: null,
    idToken: null,
    refreshToken: null,
    oAuth2TokenExpires: null,
    isAuthenticated: false
  },

  getters: {
    awsCredentials: async (state) => new AWS.Credentials({
      accessKeyId: state.accessKeyId,
      secretAccessKey: state.secretAccessKey,
      sessionToken: state.sessionToken
    }),
    oAuth2TokenExpires: state => new Date(state.oAuth2TokenExpires),
    isOAuth2TokenExpired: state => new Date(state.oAuth2TokenExpires) - new Date() < 10 * 60 * 1000, // there is less than 10 minutes left until expiry
    refreshToken: state => state.refreshToken,
    userInfo: state => state.userInfo,
    isAuthenticated: state => state.isAuthenticated,
    jwtPayload: state => state.jwtPayload
  },

  mutations: {
    setAccessKeyId: (state, accessKeyId) => {
      state.accessKeyId = accessKeyId
    },
    setSecretAccessKey: (state, secretAccessKey) => {
      state.secretAccessKey = secretAccessKey
    },
    setSessionToken: (state, sessionToken) => {
      state.sessionToken = sessionToken
    },
    setSessionExpires: (state, sessionExpires) => {
      state.sessionExpires = sessionExpires
    },
    setUserInfo: (state, userInfo) => {
      state.userInfo = userInfo
    },
    setJwtToken: (state, jwtToken) => {
      state.jwtToken = jwtToken
    },
    setJwtPayload: (state, jwtPayload) => {
      state.jwtPayload = jwtPayload
    },
    setIdToken: (state, idToken) => {
      state.idToken = idToken
    },
    setRefreshToken: (state, refreshToken) => {
      state.refreshToken = refreshToken
    },
    setOAuth2TokenExpires: (state, oAuth2TokenExpires) => {
      state.oAuth2TokenExpires = oAuth2TokenExpires
    },
    setAuthenticated: (state, isAuthenticated) => {
      state.isAuthenticated = isAuthenticated
    }
  },

  actions: {
    signout: function (context, payload) {
      context.commit('setAccessKeyId', null)
      context.commit('setSecretAccessKey', null)
      context.commit('setSessionToken', null)
      context.commit('setSessionExpires', null)
      context.commit('setUserInfo', null)
      context.commit('setJwtToken', null)
      context.commit('setJwtPayload', null)
      context.commit('setIdToken', null)
      context.commit('setRefreshToken', null)
      context.commit('setOAuth2TokenExpires', null)
      context.commit('setAuthenticated', false)
    },

    authorizationCodeGrant: async function (context, payload) {
      const code = payload.code
      const tokenData = await getOAuth2Token(code)

      const jwtToken = tokenData['access_token']
      const idToken = tokenData['id_token']
      const refreshToken = tokenData['refresh_token']

      const oAuth2TokenExpires = new Date()
      oAuth2TokenExpires.setSeconds(oAuth2TokenExpires.getSeconds() + tokenData['expires_in'])

      if (tokenData['token_type'] !== 'Bearer') {
        throw new Error(`Invalid OAuth2 token type: ${tokenData['token_type']} (expecting Bearer)`)
      }

      const jwtPayload = jwt_decode(jwtToken)
      const userInfo = await getUserInfo(jwtToken)
      const credentials = await getAwsCredentials(idToken)

      context.commit('setAccessKeyId', credentials['AccessKeyId'])
      context.commit('setSecretAccessKey', credentials['SecretKey'])
      context.commit('setSessionToken', credentials['SessionToken'])
      context.commit('setSessionExpires', credentials['Expiration'])
      context.commit('setUserInfo', userInfo)
      context.commit('setJwtToken', jwtToken)
      context.commit('setJwtPayload', jwtPayload)
      context.commit('setIdToken', idToken)
      context.commit('setRefreshToken', refreshToken)
      context.commit('setOAuth2TokenExpires', oAuth2TokenExpires)
      context.commit('setAuthenticated', true)
    },

    refreshCodeGrant: async function (context, payload) {
      const tokenData = await refreshOAuth2Token(context.getters.refreshToken)

      const jwtToken = tokenData['access_token']
      const idToken = tokenData['id_token']

      const oAuth2TokenExpires = new Date()
      oAuth2TokenExpires.setSeconds(oAuth2TokenExpires.getSeconds() + tokenData['expires_in'])

      if (tokenData['token_type'] !== 'Bearer') {
        throw new Error(`Invalid OAuth2 token type: ${tokenData['token_type']} (expecting Bearer)`)
      }

      const jwtPayload = jwt_decode(jwtToken)
      const credentials = await getAwsCredentials(idToken)

      context.commit('setAccessKeyId', credentials['AccessKeyId'])
      context.commit('setSecretAccessKey', credentials['SecretKey'])
      context.commit('setSessionToken', credentials['SessionToken'])
      context.commit('setSessionExpires', credentials['Expiration'])
      context.commit('setJwtToken', jwtToken)
      context.commit('setJwtPayload', jwtPayload)
      context.commit('setIdToken', idToken)
      context.commit('setOAuth2TokenExpires', oAuth2TokenExpires)
      context.commit('setAuthenticated', true)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/auth.js